import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { cloneDeep } from "lodash";
import { ClientClassificationType } from "models/client_classification_type";
import Pagination from "rc-pagination";
import { useEffect, useState } from "react";
    
    interface IOrderDescriptionTable{
      add: () => void;
      list: ClientClassificationType[];
      edit: (item: ClientClassificationType) => void;
      deletar: (item: ClientClassificationType) => void;
      showDelete : boolean,
      cancelRef: any,
      closeDelete: () => void;
      remove : () => void;
    }
    
    const OrderDescriptionTable = ({ add, edit, list, deletar, showDelete, cancelRef, closeDelete, remove }: IOrderDescriptionTable) => {
      const textColor = useColorModeValue("secondaryGray.900", "white");
      const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

      const countPerPage = 10;
      const [value, setValue] = useState("");
      const [currentPage, setCurrentPage] = useState(1);
      const [collection, setCollection] = useState(
        cloneDeep(list.slice(0, countPerPage))
      );
    
      const updatePage = (p: number) => {
        setCurrentPage(p);
        const to = countPerPage * p;
        const from = to - countPerPage;
        setCollection(cloneDeep(list.slice(from, to)));
      };
    
    
      useEffect(() => {
        const updatePage = (p: number) => {
          setCurrentPage(p);
          const to = countPerPage * p;
          const from = to - countPerPage;
          setCollection(cloneDeep(list.slice(from, to)));
        };
    
        const searchData = (val : string) => {
          const query = val.toLowerCase();
          setCurrentPage(1);
          const data = 
          list
              .filter(item => item.nome.toLowerCase().includes(query))
              .slice(0, countPerPage)
          setCollection(data);
        
    
    }
        
        if (!value) {
          updatePage(1);
        } else {
          searchData(value);
        }
      }, [list, value]);

      return (
        <Card flexDirection="column" overflowX={{ sm: "scroll", lg: "hidden" }}>
          <Flex
            px="25px"
            mb="16px"
            mt="16px"
            justifyContent="space-between"
            align="center"
          >
            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Listagem de Descrições de Orçamento
            </Text>
            <Button onClick={add} colorScheme="brand" variant="outline">
              Adicionar
            </Button>
          </Flex>
          <Box>


      <Stack p={4}>
          <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"

              >
               Buscar
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Buscar"
                fontWeight="500"
                w={320}
                size="md"
                onChange={e => setValue(e.target.value)}
                value={value}
              />
            </FormControl>
          </Stack>
            <Table variant="striped" color="gray.500" mb="24px" mt="12px">
              <Thead>
                <Tr>
                    <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                    >
                        #ID
                    </Flex>
                    </Th>
                    <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                    >
                        #DESCRIÇÃO
                    </Flex>
                    </Th>
                    <Th pe="10px" borderColor={borderColor} cursor="pointer">
                    <Flex
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: "10px", lg: "12px" }}
                        color="gray.400"
                    >
                        #OPÇÕES
                    </Flex>
                    </Th>
                </Tr>
              </Thead>
              <Tbody>
                {collection?.map((item, index) => {
                  return (
                    <Tr key={`${item.id}-${item.idEmpresa}-${index}`}>
                    <Td
                        
                        fontSize={{ sm: "14px" }}
                        borderColor="transparent"
                      >
                        {item.id}
                      </Td>
                      <Td
                        fontSize={{ sm: "14px" }}
                        borderColor="transparent"
                      >
                        {item.nome}
                      </Td>
                      <Td
                        fontSize={{ sm: "14px" }}
                        borderColor="transparent"
                      >
                     <Button onClick={() => {edit(item)}} colorScheme="green" variant="ghost">
                          Editar
                    </Button>
                    <Button onClick={() => {deletar(item)}} colorScheme="red" variant="ghost" ml="1">
                          Excluir
                    </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>

            <Pagination
              pageSize={countPerPage}
              onChange={updatePage}
              current={currentPage}
              total={list.length}
              style={{
                float : 'right',
                marginRight :  24
              }}
            />
    
            <AlertDialog
              isOpen={showDelete}
              leastDestructiveRef={cancelRef}
              onClose={closeDelete}
              isCentered
              motionPreset='slideInBottom'
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    Cuidado!
                  </AlertDialogHeader>
    
                  <AlertDialogBody>
                    Deseja realmente deletar esse registro?
                  </AlertDialogBody>
    
                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={closeDelete} colorScheme={'gray'}>
                      Cancelar
                    </Button>
                    <Button ref={cancelRef} onClick={remove} colorScheme={'red'}>
                      Excluir
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </Box>
        </Card>
      );
    };
    export default OrderDescriptionTable;